import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyBed({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M133.61 22.04C107.1-6.15 46.57 6 25.15 55.4 8.77 93.17 4.08 142.27 42.56 156.42c38.48 14.16 54.87-17.23 136.9-7 56.1 7 60.04-65.24 23.77-76.1-36.28-10.86-44.3-24.37-69.62-51.28z"
          fill="#E9EDFB"
        />
        <path
          d="M226.59 105.41l.02.28c1.89 22.79-12.92 48-47.14 43.73-82.04-10.23-98.43 21.16-136.91 7-20.61-7.58-28.84-25.19-29.51-45.71 36.6 4.47 69.8 14.23 139.2-7.92 34.76-11.09 57.71-7.06 74.34 2.62z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <circle fill="#F8F9FA" fillRule="nonzero" cx={146.02} cy={27.92} r={1} />
        <circle fill="#F8F9FA" fillRule="nonzero" cx={147.02} cy={27.92} r={1} />
        <circle fill="#F8F9FA" fillRule="nonzero" cx={148.02} cy={27.92} r={1} />
        <path fill="#FDE4E2" d="M49.57 102l80.29-15.44-1.43-42.81-78.86 2.67z" />
        <path
          d="M196.81 137.98l-28.78 8.53c-5.94-1-16.82-.73-32.65.84-13.81 1.37-24.1 2.73-30.85 4.07l-54.3-25.23a2 2 0 01-1.16-1.8V45.67a2 2 0 011.94-2l78.22-2.6a2 2 0 012.06 2v44.14h-3.77V46.75a2 2 0 00-2.07-2l-69.63 2.46a2 2 0 00-1.93 2v59.48l67.3 28.47h.04l75.58-17.54v18.36z"
          fill="#F89D96"
        />
        <path
          d="M198.57 139.68a757.36 757.36 0 00-32.55 8.36c-21.34-1.47-34-.45-45.5 1.38.08-1.61.08-5.76 0-12.44l78.05-18.81v21.5z"
          fill="#FDE4E2"
        />
        <path
          d="M53.52 96.5c0 3.52.03 9.99 0 12.88l67.78 29.04 77.22-17.15s1.1-7.05 0-12.8c-.77-4.08-3.04-6.1-5.8-6.8-6.67-1.66-67.76-17.04-67.76-17.04S53.52 92.97 53.52 96.5z"
          fill="#DFE5EE"
          fillRule="nonzero"
        />
        <path
          d="M54.83 96.5l67.12 25.92s57.43-12.17 75.57-15.52c1.86-.34-4.04-5.83-7.32-6.58-3.28-.74-48.62-16.39-66.63-15.69-14.35.56-67.07 6.53-68.74 11.87z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <g fillRule="nonzero">
          <path
            d="M77.31 68.74c-12.84 0-13.14 6.38-12.2 12.96 1.2 8.3 4.95 13.55 12.2 14.65 7.25 1.1 21.33-4.28 37.09-5.9 15.76-1.62 8.33-5.73 6.58-20.88-1.74-15.15-30.83-.83-43.67-.83z"
            fill="#DFE5EE"
          />
          <path
            d="M68.07 72.35c0 2.54 2.78 16.62 3.99 18.56 1.2 1.94 2.63 2.16 4.69 2.16 2.06 0 41.02-5.16 43.07-6.1 2.05-.94 2.75-2.8 2.75-4.68-.01-1.9-2.33-14.67-3.27-16.62-.94-1.95-2.42-2.81-5.03-2.4-2.6.43-40.63 4.4-42.63 4.88-2 .5-3.57 1.67-3.57 4.2z"
            fill="#FFF"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyBed.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyBed.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPicEmptyBed svgRef={ref} {...props} />);
export default ForwardRef;
